import { render, staticRenderFns } from "./CategoryList.vue?vue&type=template&id=c0adedf6&scoped=true"
import script from "./CategoryList.vue?vue&type=script&lang=js"
export * from "./CategoryList.vue?vue&type=script&lang=js"
import style0 from "./CategoryList.vue?vue&type=style&index=0&id=c0adedf6&prod&scoped=true&lang=css"
import style1 from "./CategoryList.vue?vue&type=style&index=1&id=c0adedf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0adedf6",
  null
  
)

export default component.exports